import { AddressSource } from '@forto-dev/customer-master-data-models'
import { LocationResponseV1 } from '@forto-dev/locations-models'

import { AddressFormData } from '../schema'

export const mapLocationResponseV1ToAutoCompleteAddressFormData = (
  locationResponse: LocationResponseV1
): AddressFormData => {
  const { address, addressFormatted, localAddress, localAddressFormatted } = locationResponse

  return {
    address: {
      countryCode: address.countryCode,
      locationRef: address.locationRef,
      ...(address.route1 && { route1: address.route1 }),
      ...(address.route2 && { route2: address.route2 }),
      ...(address.additionalInformation && { additionalInformation: address.additionalInformation }),
      ...(address.locality1 && { locality1: address.locality1 }),
      ...(address.locality2 && { locality2: address.locality2 }),
      ...(address.locality3 && { locality3: address.locality3 }),
      ...(address.region1 && { region1: address.region1 }),
      ...(address.region2 && { region2: address.region2 }),
      ...(address.region3 && { region3: address.region3 }),
      ...(address.region4 && { region4: address.region4 }),
      ...(address.postalCode && { postalCode: address.postalCode }),
      source: AddressSource.AUTOCOMPLETE,
    },

    localAddress: {
      countryCode: localAddress.countryCode,
      ...(localAddress.locationRef && { locationRef: localAddress.locationRef }),
      ...(localAddress.route1 && { route1: localAddress.route1 }),
      ...(localAddress.route2 && { route2: localAddress.route2 }),
      ...(localAddress.additionalInformation && { additionalInformation: localAddress.additionalInformation }),
      ...(localAddress.locality1 && { locality1: localAddress.locality1 }),
      ...(localAddress.locality2 && { locality2: localAddress.locality2 }),
      ...(localAddress.locality3 && { locality3: localAddress.locality3 }),
      ...(localAddress.region1 && { region1: localAddress.region1 }),
      ...(localAddress.region2 && { region2: localAddress.region2 }),
      ...(localAddress.region3 && { region3: localAddress.region3 }),
      ...(localAddress.region4 && { region4: localAddress.region4 }),
      ...(localAddress.postalCode && { postalCode: localAddress.postalCode }),
    },
    addressFormatted,
    localAddressFormatted,
  }
}
